import { Spine } from '@esotericsoftware/spine-pixi-v8';
import { /*Sprite,*/ Assets, BitmapText, Container, /*Text, TextStyle,*/ Graphics /*, Sprite*/ } from "pixi.js";
import { Group, Tween } from "tweedle.js";

import { sound, Sound } from "@pixi/sound";


import { betValueGlobal, currentBackgorundMusic, currentBackgorundMusicVolume } from '../config/GlobalVariableConfig';

// import { CoinAnimation } from "./CoinAnimation";



interface CustomContainer extends Container {
    value: number;
}



const decimal: number = 2;

const counterOffsetStarting = 0;
const counterOffset = 220;

export class BigWin extends Container {


    private parentContainer: Container = new Container();
    private bigWin: Spine | null = null;
    private currentAnimation: string = "NONE";
    private container: CustomContainer;// = new Container() as CustomContainer;
    private numberText: BitmapText;
    // private amtBase: Sprite;
    // private winTickupBgSpine: Spine;

    private tween: Tween<CustomContainer> | null = null;
    private tweenGroup: Group;
    private toNumber: number = 0;

    private overlay = new Graphics();
    private skipRequested: boolean = false;

    private blackLayer = new Graphics();

    // private allSoundComplete : boolean = false;

    private isBigWinLoaded: boolean = false;

    // private coins: CoinAnimation;
    // private coinsAdded: number = 0;


    private screenWidth: number;
    private screenHeight: number;


    private backGroundMusic: Sound;

    private bigWinsSound: Sound;
    // private megaWinsSound: Sound;
    // private superMegaWinsSound: Sound;
    // private epicWinsSound: Sound;



    constructor(screenWidth: number, screenHeight: number) {
        super();

        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;

        this.backGroundMusic = currentBackgorundMusic;

        this.bigWinsSound = sound.find('win_loop');

        // this.bigWinsSound = sound.find('super_mega_win_loop');
        // this.megaWinsSound = sound.find('mega_win_loop');
        // this.superMegaWinsSound = sound.find('super_mega_win_loop');
        // this.epicWinsSound = sound.find('epic_win_loop');


        // this.coins = new CoinAnimation(this.screenWidth, this.screenHeight);


        this.addChild(this.parentContainer);

        this.overlay.rect(-10000, -10000, 20000, 20000).fill(0x00e0f0); // height  width is any fuzzy value >0 later, it will be set in resize
        this.overlay.alpha = 0.01;
        this.overlay.interactive = true;
        // this.overlay.visible = false;
        this.addChild(this.overlay);
        this.overlay.visible = false;


        this.overlay.on('pointerdown', this.skip.bind(this));


        this.blackLayer.rect(-10000, -10000, 20000, 20000).fill(0x000000); // height  width is any fuzzy value >0 later, it will be set in resize
        // this.blackLayer.alpha = 0.85;
        this.parentContainer.addChild(this.blackLayer);

        // this.blackLayer.visible = false;

        this.tweenGroup = new Group();


        // Initialize the Spine animation

        this.initBigWin();

        // this.bigWin = Spine.from({
        //     skeleton: "bigWinSkel",
        //     atlas: "bigWinAtlas",
        // });


        this.container = new Container() as CustomContainer;


        // Add the animation to the parent container
        // this.parentContainer.addChild(this.bigWin);

        // Listen for the complete event on the animation state
        // this.bigWin.state.addListener({
        //     complete: this.onComplete.bind(this)
        // });

        this.parentContainer.addChild(this.container);


        // this.amtBase = Sprite.from('amount_base');
        // this.amtBase.anchor = 0.5;
        // this.container.addChild(this.amtBase);


        // this.winTickupBgSpine = Spine.from({
        //     skeleton: "winTickupSkel",
        //     atlas: "winTickupAtlas",
        // });

        // this.winTickupBgSpine.visible = false;
        // // bigwinSpineSymbol.state.setAnimation(0, "big_win_out", true);
        // this.winTickupBgSpine.state.setAnimation(0, "animation", true);
        // this.winTickupBgSpine.position.set(0, 50);

        // this.container.addChild(this.winTickupBgSpine);



        this.numberText = new BitmapText({
            text: '',
            style: {
                fontFamily: "sugar_win_amount",
                trim: true,
                fontSize: 160,
                letterSpacing: 20,
            }
        });

        this.numberText.anchor.set(0.5);
        this.numberText.position.set(0, -15);
        this.container.addChild(this.numberText);

        this.setInitAttributes();
        // this.allSoundComplete = false;

        // this.visible = false;

        this.resize(this.screenWidth, this.screenHeight);
    }


    private async initBigWin() {

        await Assets.loadBundle('big-wins');

        // this.parentContainer.addChild(this.coins);

        this.bigWin = Spine.from({
            skeleton: "bigWinSkel",
            atlas: "bigWinAtlas",
        });

        // Listen for the complete event on the animation state
        this.bigWin.state.addListener({
            complete: this.onComplete.bind(this)
        });

        // Add the animation to the parent container
        this.parentContainer.addChild(this.bigWin);


        // this.bigWin.state.data.setMix("big_win_loop", "big_win_out", 0.25); // 0.5 seconds for mix
        // this.bigWin.state.data.setMix("mega_win_loop", "mega_win_out", 0.25); // 0.5 seconds for mix
        // this.bigWin.state.data.setMix("super_mega_win_loop", "super_mega_win_out", 0.25); // 0.5 seconds for mix
        // this.bigWin.state.data.setMix("epic_win_loop", "epic_win_out", 0.25); // 0.5 seconds for mix


        this.parentContainer.addChild(this.container); // tickup container will be on top

        this.isBigWinLoaded = true;
    }


    // private start (toNumber: number, decimal: number)
    // {

    // }

    private skip(): void {
        console.log("skip button clicked");
        this.skipRequested = true;
    }

    private getFinalBigwinWhenSkipCallback(): () => void {
        console.log("skip bigwin", this.currentAnimation);


        if (this.toNumber >= 20 * betValueGlobal && this.toNumber < 50 * betValueGlobal) {
            if (this.currentAnimation === "big_win_loop" || this.currentAnimation === "big_win_in") {
                return () => { /* No function needed to call */ };
            } else {
                return this.playBigWinIn.bind(this);
            }

        } else if (this.toNumber >= 50 * betValueGlobal && this.toNumber < 100 * betValueGlobal) {
            if (this.currentAnimation === "mega_win_loop" || this.currentAnimation === "mega_win_in") {
                return () => { /* No function needed to call */ };
            } else {
                return this.playMegaWinIn.bind(this);
            }

        } else if (this.toNumber >= 100 * betValueGlobal && this.toNumber < 250 * betValueGlobal) {
            if (this.currentAnimation === "super_mega_win_loop" || this.currentAnimation === "super_mega_win_in") {
                return () => { /* No function needed to call */ };
            } else {
                return this.playSuperMegaWinIn.bind(this);
            }

        } else if (this.toNumber >= 250 * betValueGlobal) {
            if (this.currentAnimation === "epic_win_loop" || this.currentAnimation === "epic_win_in") {
                return () => { /* No function needed to call */ };
            } else {
                return this.playEpicWinIn.bind(this);
            }

        } else {
            return () => { /* No function needed to call */ };
        }
    }

    // public check()
    // {
    //     this.bigWin.state.setAnimation(0, "big_win_loop", true);
    //     this.numberText.text = "999"
    // }

    private setInitAttributes(): void {

        this.container.y = counterOffsetStarting;
        // this.amtBase.visible = false;
        // this.winTickupBgSpine.visible = false;

        this.container.value = 0;
        this.container.scale.set(0);
        this.container.alpha = 0;

        // this.coins.visible = false;
        // this.coinsAdded = 0;
        // this.coins.stopCoinAnimation();

        this.overlay.visible = false;
        // this.blackLayer.visible = false;

        this.blackLayer.alpha = 0;

        this.skipRequested = false;

    }

    public async bigWinFunction(winAmt: number | null): Promise<void> {


        if (winAmt && winAmt < 20 * betValueGlobal) {
            return Promise.resolve();
        }

        // await this.start(10 );

        this.setInitAttributes();

        if (this.bigWin) {
            this.bigWin.scale = 1;
            this.bigWin.alpha = 1;
            this.bigWin.visible = false;
        }



        if (winAmt && winAmt > 0) {

            // this.visible = true;

            this.currentAnimation = "NONE";


            if (!this.isBigWinLoaded && winAmt >= 20 * betValueGlobal) {
                await this.waitForBigwinAssetLoad();
            }


            await this.start(winAmt);

            // this.bigWin?.destroy();
            // console.log("big win ends");
        }
        else {
            return Promise.resolve();
        }
    }

    // Function to check the isBigWinLoaded status every 200 milliseconds
    private async waitForBigwinAssetLoad(): Promise<void> {
        return new Promise((resolve) => {
            const checkInterval = setInterval(() => {
                if (this.isBigWinLoaded) {
                    clearInterval(checkInterval); // Stop checking once isBigWinLoaded is true
                    resolve(); // Resolve the promise
                }
            }, 200); // Check every 200 milliseconds
        });
    }


    private setonStartAttributes(): void {

        this.container.y = counterOffsetStarting;
        // this.amtBase.visible = false;
        // this.winTickupBgSpine.visible = true;

        // doing it through tween in start()
        // this.container.value = 0;
        // this.container.scale.set(1);
        // this.container.alpha = 1;

        // this.coins.visible = false;
        // this.coinsAdded = 0;
        // this.coins.stopCoinAnimation();

        this.overlay.visible = true;
        // this.blackLayer.visible = false;

    }



    private adjustBackgroundMusicVolume(toNumber: number) {
        this.backGroundMusic = currentBackgorundMusic;
        // let currentVal: number = this.backGroundMusic.volume;
        let currentVal: number = this.backGroundMusic?.volume;
        let targetVal: number = toNumber;


        if (this.backGroundMusic) {

            // console.log("\ninside this.backGroundMusic", currentVal, targetVal);

            const tween = new Tween({ x: currentVal }, this.tweenGroup)
                .to({ x: targetVal }, 500)
                .onUpdate((object) => {
                    this.backGroundMusic.volume = object.x;
                    // console.log("this.backGroundMusic", this.backGroundMusic.volume);
                })
                .onComplete(() => {

                    this.tweenGroup.remove(tween);
                    this.backGroundMusic.volume = toNumber;
                })
                .start();

        }

    }

    private playWinTickupSmoothly() {
        const tickupSound = sound.find('win_tickup');

        if (tickupSound) {
            tickupSound.loop = true;
            tickupSound.volume = 0;
            tickupSound.singleInstance = true;
            tickupSound.play();
        }

        let currentVal = 0;
        let targetVal = .4;

        const tween = new Tween({ x: currentVal }, this.tweenGroup)
            .to({ x: targetVal }, 1000)
            .onUpdate((object) => {
                tickupSound.volume = object.x;
            })
            .onComplete(() => {

                this.tweenGroup.remove(tween);

            })
            .start();

    }

    private async start(toNumber: number): Promise<void> {

        this.toNumber = toNumber;

        // this.backGroundMusic.volume = 0;

        this.setonStartAttributes();



        let tweenDuration: number;

        let speedMultiplier: number = 1;
        let targetSpeedMultiplier: number = 1; // Desired speed multiplier when condition is met
        const smoothTransitionFactor: number = 0.5; // Adjust this value to control the smoothness

        if (this.toNumber <= 1 * betValueGlobal) {
            tweenDuration = 0;
        }
        else if (this.toNumber <= 10 * betValueGlobal) {
            tweenDuration = 1000;
        }
        else {
            tweenDuration = 100 * Math.floor(this.toNumber / betValueGlobal);
        }


        let updateCounter = 0; // Initialize a counter to keep track of updates
        const logFrequency = 5; // Log every 4th update to print 15 times (60 / 15 = 4)

        let previousWidth = this.numberText.width; // Track the previous width


        await new Promise<void>((resolve) => {
            this.tween = new Tween(this.container, this.tweenGroup)
                .to({ value: this.toNumber }, tweenDuration)
                .onStart(() => {

                    if (tweenDuration > 0) {
                        this.adjustBackgroundMusicVolume(0.10);
                        this.playWinTickupSmoothly();

                    }
                })
                .onUpdate(async () => {

                    updateCounter++; // Increment the counter on each update

                    if (this.skipRequested) {

                        sound.stop('win_tickup');
                        sound.play('win_tickup_end', { volume: .4 });
                        // this.adjustBackgroundMusicVolume(1);

                        this.tween!.stop();
                        // this.container.value = this.toNumber;
                        // this.numberText.text = parseFloat(this.container.value.toFixed(decimal)).toFixed(decimal).toString();

                        this.numberText.text = this.toNumber.toFixed(decimal);

                        this.numberText.scale = 1;
                        const scale = Math.min(650 / this.numberText.width, 1);
                        this.numberText.scale.set(scale, scale);

                        const finalBigwinWhenSkip = this.getFinalBigwinWhenSkipCallback();

                        finalBigwinWhenSkip();

                        await this.endAnimation();
                        resolve();

                        if (this.tween) {
                            this.tweenGroup.remove(this.tween);
                        }

                    }

                    if (updateCounter % logFrequency === 0) {
                        this.numberText.text = parseFloat(this.container.value.toFixed(decimal)).toFixed(decimal).toString();

                        // Only apply scaling if the width has changed
                        if (this.numberText.width > previousWidth) {

                            // console.log("this.numberText.width", this.numberText.width);

                            this.numberText.scale = 1;
                            const scale = Math.min(650 / this.numberText.width, 1);
                            this.numberText.scale.set(scale, scale); // Apply scaling



                            // Update the previous width after scaling
                            previousWidth = this.numberText.width;
                        }

                    }



                    // Check and adjust tween speed gradually when the condition is met
                    if (this.container.value >= 100 * betValueGlobal && targetSpeedMultiplier === 1) {
                        targetSpeedMultiplier = 4; // Set target speed multiplier to double speed
                    }
                    else if (this.container.value >= 250 * betValueGlobal && targetSpeedMultiplier === 4) {
                        targetSpeedMultiplier = 10; // Set target speed multiplier to double speed
                    }
                    else if (this.container.value >= 500 * betValueGlobal && targetSpeedMultiplier === 10) {
                        targetSpeedMultiplier = 25; // Set target speed multiplier to double speed
                    }
                    else if (this.container.value >= 1000 * betValueGlobal && targetSpeedMultiplier === 25) {
                        targetSpeedMultiplier = 500; // Set target speed multiplier to double speed
                    }

                    // if (this.container.value >= 1000 * betValueGlobal && targetSpeedMultiplier === 5) {
                    //     targetSpeedMultiplier = 20; // Set target speed multiplier to double speed
                    // }

                    // Gradually interpolate the speed multiplier towards the target value
                    if (speedMultiplier < targetSpeedMultiplier) {
                        speedMultiplier = Math.min(speedMultiplier + smoothTransitionFactor, targetSpeedMultiplier);
                        this.tween!.timescale(speedMultiplier);
                    }

                    // Animation transitions based on updated win thresholds
                    if (this.toNumber >= 20 * betValueGlobal && this.container.value >= 20 * betValueGlobal && this.currentAnimation === "NONE") {
                        this.playBigWinIn();  // Big Win threshold
                    }
                    if (this.toNumber >= 50 * betValueGlobal && this.container.value >= 50 * betValueGlobal && this.currentAnimation === "big_win_loop") {
                        this.playBigWinOut();
                        this.playMegaWinIn();  // Mega Win threshold
                    }
                    if (this.toNumber >= 100 * betValueGlobal && this.container.value >= 100 * betValueGlobal && this.currentAnimation === "mega_win_loop") {
                        this.playMegaWinOut();
                        this.playSuperMegaWinIn();  // Super Mega Win threshold
                    }
                    if (this.toNumber >= 250 * betValueGlobal && this.container.value >= 250 * betValueGlobal && this.currentAnimation === "super_mega_win_loop") {
                        this.playSuperMegaWinOut();
                        this.playEpicWinIn();  // Epic Win threshold
                    }

                })
                .onComplete(async () => {

                    this.numberText.text = parseFloat(this.container.value.toFixed(decimal)).toFixed(decimal).toString();

                    this.numberText.scale = 1;
                    const scale = Math.min(650 / this.numberText.width, 1);
                    this.numberText.scale.set(scale, scale);

                    if (tweenDuration > 0) {
                        sound.stop('win_tickup');
                        sound.play('win_tickup_end', { volume: .4 });
                    }

                    // if (!this.skipRequested) {
                    await this.endAnimation();
                    // }
                    resolve();
                    if (this.tween) {
                        this.tweenGroup.remove(this.tween);
                    }
                })
                .start();




            // tween to scale the appearance of text tickup

            const tween = new Tween(this.container, this.tweenGroup)
                .to({ scale: { x: 1, y: 1 }, alpha: 1 }, 200)
                .onComplete(() => {
                    this.tweenGroup.remove(tween)
                })
                .start();
        });
    }



    private setonBigwinStartAttributes(): void {

        this.container.y = counterOffset;
        // this.amtBase.visible = true;
        // this.winTickupBgSpine.visible = true; // already done

        // already done
        // this.container.value = 0;
        // this.container.scale.set(1);
        // this.container.alpha = 1;

        // this.winTickupBgSpine.visible = false;

        if (this.bigWin && !this.bigWin.visible) { this.bigWin.visible = true; }

        this.blackLayer.alpha = 0.85;
        // this.blackLayer.visible = true;


    }


    private playBigWinIn(): void {

        this.setonBigwinStartAttributes();

        this.currentAnimation = "big_win_in";
        this.bigWin?.state.setAnimation(0, "big_win_in", false);

        // sound.play('big_win_in', {
        //     complete: () => {
        //         this.bigWinsSound.play({ loop: true, singleInstance: true });
        //     }
        // });


        if (!this.skipRequested) {
            // this.bigWinsSound.play({ loop: true, singleInstance: true });
            // sound.play('big_win_in', {
            //     complete: () => {
            //         this.bigWinsSound.play({ loop: true, volume: 1, singleInstance: true });
            //     }
            // });

            // sound.play('Win_Tear_Impact', { volume: .5, speed: 1 });
            this.bigWinsSound.play({ loop: true, volume: 1, singleInstance: true });
        }

        console.log("bigwin animation name playBigWinIn")

    }


    private playBigWinLoop(): void {

        this.setonBigwinStartAttributes();

        this.currentAnimation = "big_win_loop";
        this.bigWin?.state.setAnimation(0, "big_win_loop", true);
        // this.bigWinsSound.play({ loop: true, singleInstance: true });

        console.log("bigwin animation name playBigWinLoop")

    }

    private playBigWinOut(): void {

        this.setonBigwinStartAttributes();

        this.currentAnimation = "big_win_out";
        this.bigWin?.state.setAnimation(0, "big_win_out", false);
        // sound.stop('big_win_loop');
        // sound.play('big_win_out')
        // this.bigWinsSound.stop();
        console.log("bigwin animation name playBigWinOut")
    }

    private playMegaWinIn(): void {

        this.setonBigwinStartAttributes();

        this.currentAnimation = "mega_win_in";
        this.bigWin?.state.setAnimation(0, "mega_win_in", false);
        // sound.play('mega_win_in');
        if (!this.skipRequested) {
            // this.megaWinsSound.play({ loop: true, singleInstance: true })
            // sound.play('Mega_Win_Transition', { volume: 0.7, speed: 1 });
            sound.play('Win_Tear_Impact', { volume: 0.15, speed: 1 });


        }

        console.log("bigwin animation name playMegaWinIn")
    }

    private playMegaWinLoop(): void {

        this.setonBigwinStartAttributes();

        this.currentAnimation = "mega_win_loop";
        this.bigWin?.state.setAnimation(0, "mega_win_loop", true);
        // sound.play('mega_win_loop', { loop: true, singleInstance: true })



        console.log("bigwin animation name playMegaWinLoop")
    }

    private playMegaWinOut(): void {
        this.setonBigwinStartAttributes();
        this.currentAnimation = "mega_win_out";
        this.bigWin?.state.setAnimation(0, "mega_win_out", false);
        // this.megaWinsSound.stop();

        // sound.stop('mega_win_loop');
        // sound.play('mega_win_out');
        console.log("bigwin animation name playMegaWinOut");
    }

    private playSuperMegaWinIn(): void {
        this.setonBigwinStartAttributes();
        this.currentAnimation = "super_mega_win_in";
        this.bigWin?.state.setAnimation(0, "super_mega_win_in", false);
        // sound.play('Win_Tear_Impact');
        if (!this.skipRequested) {
            // this.superMegaWinsSound.play({ loop: true, singleInstance: true })
            // sound.play('Super_Win_Transition', { volume: 0.7, speed: 1 });
            sound.play('Win_Tear_Impact', { volume: 0.15, speed: 1 });

        }

        console.log("bigwin animation name playSuperMegaWinIn");
    }

    private playSuperMegaWinLoop(): void {
        this.setonBigwinStartAttributes();
        this.currentAnimation = "super_mega_win_loop";
        this.bigWin?.state.setAnimation(0, "super_mega_win_loop", true);
        // sound.play('super_mega_win_loop', { loop: true, singleInstance: true });

        console.log("bigwin animation name playSuperMegaWinLoop");
    }

    private playSuperMegaWinOut(): void {
        this.setonBigwinStartAttributes();
        this.currentAnimation = "super_mega_win_out";
        this.bigWin?.state.setAnimation(0, "super_mega_win_out", false);
        // sound.stop('super_mega_win_loop');
        // sound.play('super_mega_win_out');
        // this.superMegaWinsSound.stop();
        console.log("bigwin animation name playSuperMegaWinOut");
    }

    private playEpicWinIn(): void {

        this.setonBigwinStartAttributes();

        this.currentAnimation = "epic_win_in";
        this.bigWin?.state.setAnimation(0, "epic_win_in", false);
        // sound.play('epic_win_in');
        if (!this.skipRequested) {
            // this.epicWinsSound.play({ loop: true, singleInstance: true })
            // sound.play('Epic_Win_Transition', { volume: 0.7, speed: 1 });
            sound.play('Win_Tear_Impact', { volume: 0.15, speed: 1 });

        }

        console.log("bigwin animation name playEpicWinIn")
    }

    private playEpicWinLoop(): void {

        this.setonBigwinStartAttributes();

        this.currentAnimation = "epic_win_loop";
        this.bigWin?.state.setAnimation(0, "epic_win_loop", true);



        console.log("bigwin animation name epic_win_loop")
    }

    // private playEpicWinOut(): void {

    //     this.setonBigwinStartAttributes();

    //     this.currentAnimation = "epic_win_out";
    //     this.bigWin?.state.setAnimation(0, "epic_win_out", false);
    //     sound.stop('epic_win_loop');
    //     sound.play('epic_win_out')

    //     console.log("bigwin animation name playEpicWinOut")
    // }




    private onComplete(): void {
        if (this.currentAnimation === "big_win_in") {
            this.playBigWinLoop();
        }
        else if (this.currentAnimation === "big_win_out") {
            this.playMegaWinIn();  // Transition to Mega Win after Big Win Out
        }
        else if (this.currentAnimation === "mega_win_in") {
            this.playMegaWinLoop();
        }
        else if (this.currentAnimation === "mega_win_out") {
            this.playSuperMegaWinIn();  // Transition to Super Mega Win after Mega Win Out
        }
        else if (this.currentAnimation === "super_mega_win_in") {
            this.playSuperMegaWinLoop();
        }
        else if (this.currentAnimation === "super_mega_win_out") {
            this.playEpicWinIn();  // Transition to Epic Win after Super Mega Win Out
        }
        else if (this.currentAnimation === "epic_win_in") {
            this.playEpicWinLoop();
        }
    }


    private stopBackgroundMusic() {
        let currentVal: number = this.bigWinsSound?.volume || 0; // Ensure a default value
        let targetVal: number = 0;

        if (this.bigWinsSound && this.bigWinsSound.isPlaying) { // Check if sound is playing
            const tween = new Tween({ x: currentVal }, this.tweenGroup)
                .to({ x: targetVal }, 500)
                .onUpdate((object) => {
                    this.bigWinsSound.volume = object.x;
                })
                .onComplete(() => {
                    this.tweenGroup.remove(tween);
                    this.bigWinsSound.stop()
                    this.bigWinsSound.volume = 1;
                })
                .start();
        }
    }



    private async endAnimation(): Promise<void> {


        if (this.toNumber > 20 * betValueGlobal) {
            await new Promise(resolve => setTimeout(resolve, 1000));
        }
        else if (this.toNumber > 0) {
            await new Promise(resolve => setTimeout(resolve, 500));
        }
        else {
            await new Promise(resolve => setTimeout(resolve, 100));
        }

        const winAmtDisappearDelay = this.toNumber <= 20 * betValueGlobal ? 0 : 0;
        // const winAmtDisappearDelay = this.toNumber <= 20 * betValueGlobal ? 0 : 500;


        const playEndSound = () => {

            console.log(`this.currentAnimation ${this.currentAnimation}`);

            // Stop all loop sounds
            // sound.stop('big_win_loop');
            // sound.stop('mega_win_loop');
            // sound.stop('super_mega_win_loop');
            // sound.stop('epic_win_loop');
            // this.bigWinsSound.stop();
            // sound.play("big_win_out");

            this.stopBackgroundMusic();

            // this.megaWinsSound.stop();
            // this.superMegaWinsSound.stop();
            // this.epicWinsSound.stop();
            // sound.play('big_win_out');

            // Play the appropriate end sound based on the current animation
            // if (this.currentAnimation === "big_win_loop") {
            //     this.bigWinsSound.stop();
            // }
            // else if (this.currentAnimation === "mega_win_loop") {
            //     this.megaWinsSound.stop();
            // }
            // else if (this.currentAnimation === "super_mega_win_loop") {
            //     this.superMegaWinsSound.stop();
            // }
            // else if (this.currentAnimation === "epic_win_loop") {
            //     this.epicWinsSound.stop();
            // }
        };


        await Promise.all([
            new Promise<void>((resolve) => {
                const tween = new Tween(this.bigWin, this.tweenGroup)
                    .to({ scale: { x: 0, y: 0 }, alpha: 0 }, 250)
                    .onStart(() => {
                        playEndSound();
                    })
                    .onComplete(() => {
                        setTimeout(() => {
                            this.tweenGroup.remove(tween);
                            resolve();
                        }, winAmtDisappearDelay);
                    })
                    .start();
            }),

            new Promise<void>((resolve) => {
                const tween = new Tween(this.container, this.tweenGroup)
                    .to({ /*scale: { x: 0.9, y: 0.9 },*/ alpha: 0 }, 250)
                    .onComplete(() => {
                        this.tweenGroup.remove(tween);
                        resolve();
                    })
                    .start();
            }),

            new Promise<void>((resolve) => {
                const tween = new Tween(this.blackLayer, this.tweenGroup)
                    .to({ alpha: 0 }, 250)
                    .onComplete(() => {

                        this.tweenGroup.remove(tween)
                        resolve();
                    })
                    .start();
            })

        ]);

        // just to end the animation ( the scale is 0 atm so following will not be visisble at all)
        this.bigWin?.state.setAnimation(0, "epic_win_out", false);

        // this.blackLayer.visible = false;


        this.overlay.visible = false;

        // this.backGroundMusic.volume = 1;
        this.adjustBackgroundMusicVolume(currentBackgorundMusicVolume);

        // this.visible = false;


        // this.bigWin.destroy();
    }


    public update(): void {
        // Update the tween group
        this.tweenGroup.update();

    }


    public resize(screenWidth: number, screenHeight: number): void {

        console.log(screenWidth, screenHeight);

        // this.coins.resize(screenWidth, screenHeight);

    }


}
